import { render, staticRenderFns } from "./OptionsOrder.vue?vue&type=template&id=95b9c5a4&scoped=true&"
import script from "./OptionsOrder.vue?vue&type=script&lang=js&"
export * from "./OptionsOrder.vue?vue&type=script&lang=js&"
import style0 from "./OptionsOrder.vue?vue&type=style&index=0&id=95b9c5a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b9c5a4",
  null
  
)

export default component.exports